module.exports = __webpack_public_path__ + "img/Catalonia.e536cbb6.png";